<template>
    <div
        v-if="visible"
        class="block-context-menu fixed z-[10000] bg-white shadow-xl rounded-md border border-gray-200 py-1 text-sm min-w-[280px]"
        :style="{ top: y + 'px', left: x + 'px' }"
        @click.stop
    >
        <div class="px-4 py-3 border-b border-gray-100">
            <div class="text-xs text-gray-400 uppercase tracking-wide">Canvas block</div>
            <div class="text-sm font-semibold text-gray-800 truncate">{{ blockDisplayName }}</div>
            <div v-if="alreadyExcluded" class="mt-1 text-xs text-orange-500">
                Currently excluded from this context
            </div>
        </div>

        <button
            type="button"
            class="w-full text-left px-4 py-2 hover:bg-indigo-50 flex items-center gap-3"
            @click="$emit('exclude-context')"
            :disabled="!contextKey"
            :class="{ 'opacity-40 cursor-not-allowed': !contextKey }"
        >
            <i class="fa-regular fa-ban text-gray-500 w-4 text-center"></i>
            <span v-if="contextKey">
                Exclude from <strong>{{ contextLabel || contextKey }}</strong>
            </span>
            <span v-else class="text-gray-400">Exclude from context (unavailable)</span>
        </button>

        <div class="border-t border-gray-100 my-1"></div>

        <button
            type="button"
            class="w-full text-left px-4 py-2 hover:bg-red-50 flex items-center gap-3 text-red-600"
            @click="$emit('disable-website')"
        >
            <i class="fa-regular fa-eye-slash w-4 text-center"></i>
            <span>Hide from this website</span>
        </button>

        <button
            v-if="resellerEnabled"
            type="button"
            class="w-full text-left px-4 py-2 hover:bg-red-50 flex items-center gap-3 text-red-600"
            @click="$emit('disable-reseller')"
        >
            <i class="fa-regular fa-eye-slash w-4 text-center"></i>
            <span>Hide from reseller</span>
        </button>

        <div class="border-t border-gray-100 my-1"></div>

        <button
            type="button"
            class="w-full text-left px-4 py-2 hover:bg-gray-50 text-gray-500 text-xs"
            @click="$emit('close')"
        >
            Cancel
        </button>
    </div>
</template>

<script>
export default {
    name: 'BlockContextMenu',

    props: {
        visible: { type: Boolean, default: false },
        x: { type: Number, default: 0 },
        y: { type: Number, default: 0 },
        block: { type: Object, default: () => ({}) },
        contextKey: { type: String, default: null },
        contextLabel: { type: String, default: null },
        alreadyExcluded: { type: Boolean, default: false },
        resellerEnabled: { type: Boolean, default: false },
    },

    computed: {
        blockDisplayName() {
            // Always prefer the human-readable block name from meta; never show
            // the raw block id (e.g. "canvas::common.slider") in the header.
            return (this.block && this.block.meta && this.block.meta.name) || 'Unknown block';
        },
    },

    mounted() {
        document.addEventListener('click', this.handleOutsideClick);
        document.addEventListener('keydown', this.handleEscape);
    },

    beforeDestroy() {
        document.removeEventListener('click', this.handleOutsideClick);
        document.removeEventListener('keydown', this.handleEscape);
    },

    methods: {
        handleOutsideClick() {
            if (this.visible) {
                this.$emit('close');
            }
        },
        handleEscape(e) {
            if (e.key === 'Escape' && this.visible) {
                this.$emit('close');
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.block-context-menu {
    user-select: none;
}
</style>
